import { useId, useState } from 'react';

import Arrow from '../../assets/icons/arrow-down.svg';
import { isRightToLeft } from '../../utils/helpers/functions.helper';

import './Accordion.scss';

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rightToLeft = isRightToLeft();
  const accordionId = useId();
  const buttonId = `accordion-button-${accordionId}`;
  const panelId = `accordion-panel-${accordionId}`;

  const toggleAccordion = () => {
    setIsOpen((currentIsOpen) => !currentIsOpen);
  };

  return (
    <div className="accordion">
      <button
        id={buttonId}
        type="button"
        aria-expanded={isOpen}
        aria-controls={panelId}
        className={`accordionTitle ${isOpen ? 'open' : ''}`}
        onClick={toggleAccordion}
      >
        <span className={rightToLeft ? 'titleRTL' : 'title'}>{title}</span>
        <img
          className={rightToLeft ? 'arrowRTL' : 'arrow'}
          src={Arrow}
          alt=""
          aria-hidden="true"
        />
      </button>

      <div
        id={panelId}
        className={`accordionItem ${isOpen ? '' : 'collapsed'}`}
        role="region"
        aria-labelledby={buttonId}
        aria-hidden={!isOpen}
      >
        <div className="accordionContent">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
